import './App.scss';

export { default } from './App';
